const __WEBPACK_NAMESPACE_OBJECT__ = jsmodule["@/shiny.react"];